import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldCheck, Lock, CreditCard, Check } from 'lucide-react';
import { motion } from 'framer-motion';
export function CheckoutPage() {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate payment processing
    setTimeout(() => {
      navigate('/thank-you');
    }, 1500);
  };
  return <div className="min-h-screen bg-ivory font-sans text-brown selection:bg-gold selection:text-white pb-20" data-id="element-9">
      {/* Minimalist Header */}
      <header className="bg-white py-6 border-b border-gold/10 text-center shadow-sm" data-id="element-10">
        <h1 className="font-serif text-2xl text-brown" data-id="element-11">
          El Protocolo Circadiano
        </h1>
      </header>

      <main className="max-w-5xl mx-auto px-4 pt-12" data-id="element-12">
        <div className="grid lg:grid-cols-12 gap-10" data-id="element-13">
          {/* Left Column: Form */}
          <div className="lg:col-span-7" data-id="element-14">
            <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} className="bg-white rounded-2xl p-6 md:p-8 shadow-elegant border border-gold/10" data-id="element-15">
              <h2 className="text-xl font-serif mb-6 flex items-center gap-2" data-id="element-16">
                <Lock className="w-5 h-5 text-gold" data-id="element-17" />
                Finalizar Compra Segura
              </h2>

              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-18">
                {/* Contact Info */}
                <div className="space-y-4" data-id="element-19">
                  <h3 className="text-sm font-medium text-brown/70 uppercase tracking-wider" data-id="element-20">
                    Información de Contacto
                  </h3>
                  <div className="grid grid-cols-2 gap-4" data-id="element-21">
                    <div className="col-span-2 md:col-span-1" data-id="element-22">
                      <label className="block text-sm mb-1 text-brown/80" data-id="element-23">
                        Nombre
                      </label>
                      <input required type="text" className="w-full px-4 py-3 rounded-lg border border-brown/20 focus:border-gold focus:ring-1 focus:ring-gold outline-none transition-colors bg-cream/50" placeholder="Tu nombre" data-id="element-24" />
                    </div>
                    <div className="col-span-2 md:col-span-1" data-id="element-25">
                      <label className="block text-sm mb-1 text-brown/80" data-id="element-26">
                        Apellidos
                      </label>
                      <input required type="text" className="w-full px-4 py-3 rounded-lg border border-brown/20 focus:border-gold focus:ring-1 focus:ring-gold outline-none transition-colors bg-cream/50" placeholder="Tus apellidos" data-id="element-27" />
                    </div>
                    <div className="col-span-2" data-id="element-28">
                      <label className="block text-sm mb-1 text-brown/80" data-id="element-29">
                        Correo Electrónico
                      </label>
                      <input required type="email" className="w-full px-4 py-3 rounded-lg border border-brown/20 focus:border-gold focus:ring-1 focus:ring-gold outline-none transition-colors bg-cream/50" placeholder="donde recibirás el acceso" data-id="element-30" />
                    </div>
                  </div>
                </div>

                <hr className="border-gold/10" data-id="element-31" />

                {/* Payment Info */}
                <div className="space-y-4" data-id="element-32">
                  <h3 className="text-sm font-medium text-brown/70 uppercase tracking-wider" data-id="element-33">
                    Pago Seguro
                  </h3>
                  <div className="bg-cream/50 p-4 rounded-lg border border-brown/20" data-id="element-34">
                    <div className="flex items-center justify-between mb-4" data-id="element-35">
                      <span className="flex items-center gap-2 font-medium" data-id="element-36">
                        <CreditCard className="w-5 h-5 text-brown/60" data-id="element-37" />
                        Tarjeta de Crédito / Débito
                      </span>
                      <div className="flex gap-1" data-id="element-38">
                        <div className="w-8 h-5 bg-brown/10 rounded" data-id="element-39"></div>
                        <div className="w-8 h-5 bg-brown/10 rounded" data-id="element-40"></div>
                        <div className="w-8 h-5 bg-brown/10 rounded" data-id="element-41"></div>
                      </div>
                    </div>

                    <div className="space-y-3" data-id="element-42">
                      <input required type="text" placeholder="Número de tarjeta" className="w-full px-4 py-3 rounded-lg border border-brown/20 focus:border-gold focus:ring-1 focus:ring-gold outline-none transition-colors bg-white" data-id="element-43" />
                      <div className="grid grid-cols-2 gap-3" data-id="element-44">
                        <input required type="text" placeholder="MM/AA" className="w-full px-4 py-3 rounded-lg border border-brown/20 focus:border-gold focus:ring-1 focus:ring-gold outline-none transition-colors bg-white" data-id="element-45" />
                        <input required type="text" placeholder="CVC" className="w-full px-4 py-3 rounded-lg border border-brown/20 focus:border-gold focus:ring-1 focus:ring-gold outline-none transition-colors bg-white" data-id="element-46" />
                      </div>
                    </div>
                  </div>
                </div>

                <button type="submit" disabled={isSubmitting} className="w-full py-4 bg-gold hover:bg-gold-dark text-white rounded-xl font-medium text-lg transition-colors flex items-center justify-center gap-2 disabled:opacity-70" data-id="element-47">
                  {isSubmitting ? 'Procesando...' : 'Completar Pedido - $17.00'}
                  {!isSubmitting && <Lock className="w-4 h-4" data-id="element-48" />}
                </button>
              </form>

              {/* Social Proof & Trust */}
              <div className="mt-8 text-center" data-id="element-49">
                <p className="text-sm font-medium text-terracotta mb-4" data-id="element-50">
                  "Más de 1,200 mujeres ya han reseteado su ritmo este mes"
                </p>
                <div className="flex justify-center gap-4 text-brown/40" data-id="element-51">
                  <ShieldCheck className="w-8 h-8" data-id="element-52" />
                  <Lock className="w-8 h-8" data-id="element-53" />
                  <Check className="w-8 h-8" data-id="element-54" />
                </div>
              </div>
            </motion.div>
          </div>

          {/* Right Column: Order Summary */}
          <div className="lg:col-span-5" data-id="element-55">
            <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1
          }} className="bg-white rounded-2xl p-6 md:p-8 shadow-elegant border border-gold/10 sticky top-6" data-id="element-56">
              <h3 className="font-serif text-xl mb-6 border-b border-gold/10 pb-4" data-id="element-57">
                Resumen del Pedido
              </h3>

              <div className="flex gap-4 mb-6" data-id="element-58">
                <div className="w-20 h-24 bg-cream rounded-lg overflow-hidden flex-shrink-0 border border-gold/20" data-id="element-59">
                  <img src="https://cdn.magicpatterns.com/uploads/76SyMP4BbeQhGyCLJ1CrLg/Gemini_Generated_Image_aek4ypaek4ypaek4.png" alt="Protocolo" className="w-full h-full object-cover" data-id="element-60" />
                </div>
                <div data-id="element-61">
                  <h4 className="font-medium text-brown leading-tight mb-1" data-id="element-62">
                    El Protocolo de Desinflamación Circadiana
                  </h4>
                  <p className="text-sm text-brown/60 mb-2" data-id="element-63">
                    Acceso Digital Inmediato
                  </p>
                  <p className="font-medium" data-id="element-64">$17.00</p>
                </div>
              </div>

              <div className="space-y-3 text-sm text-brown/80 mb-6 border-t border-gold/10 pt-4" data-id="element-65">
                <div className="flex justify-between" data-id="element-66">
                  <span data-id="element-67">Subtotal</span>
                  <span data-id="element-68">$17.00</span>
                </div>
                <div className="flex justify-between text-terracotta" data-id="element-69">
                  <span data-id="element-70">Descuento aplicado</span>
                  <span data-id="element-71">-$0.00</span>
                </div>
                <div className="flex justify-between font-medium text-lg text-brown pt-2 border-t border-gold/10" data-id="element-72">
                  <span data-id="element-73">Total</span>
                  <span data-id="element-74">$17.00</span>
                </div>
              </div>

              {/* Guarantee Seal */}
              <div className="bg-cream/50 rounded-xl p-4 flex gap-4 items-start border border-gold/20" data-id="element-75">
                <ShieldCheck className="w-8 h-8 text-gold flex-shrink-0 mt-1" data-id="element-76" />
                <div data-id="element-77">
                  <h4 className="font-medium text-sm mb-1" data-id="element-78">
                    Garantía de 7 Días
                  </h4>
                  <p className="text-xs text-brown/70 leading-relaxed" data-id="element-79">
                    Si no notas una mejora en tu sueño e inflamación, te
                    devolvemos el 100% de tu dinero. Compra sin riesgo.
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </main>
    </div>;
}